import React from 'react'
import { compose } from 'recompose'
import withFetchResources from 'hocs/bases/withFetchResources'
import withIntl from 'store/intl/withIntl'
import CmsApis from 'apis/cmsApis'
import { updateObject } from 'helpers/objectHelpers'
import FormSelect from 'components/forms/bases/FormSelect'

const styles = {
  wrapper: {
    display: 'flex',
  },
  label: {
    width: '10%',
    margin: '5px 30px 0 10px',
    fontWeight: 400,
    fontSize: 15,
  },
  formSelect: {
    width: '60%',
    marginLeft: 15,
  },
};

const CategoryMenusContent = compose(
  withIntl(),
  withFetchResources({
    resourceName: 'menusOptions',
    getAction: () => CmsApis.getMenus,
  }),
)((props) => {
  const {
    valueContent,
    valueContent: {
      menuId = '',
      categoryTitle = '',
    },
    onChangeContent,
    menusOptions,
    fetchMenusOptionsStatus,
    currentLang,
  } = props
  const selectedMenu = ((menusOptions.find((eachMenu) => eachMenu.id === menuId) || {}).data) || []
  const handleChange = (val, key) => onChangeContent(updateObject(valueContent, { [key]: val }))
  return (
    <div>
      <div style={styles.wrapper}>
        <h3 style={styles.label}>Menu</h3>
        <FormSelect
          disabled={fetchMenusOptionsStatus.isRequest}
          value={fetchMenusOptionsStatus.isRequest ? '' : menuId}
          onChange={(val) => {
            const menuSelected = (menusOptions.find((menuOption) => menuOption.id === val) || {})
            handleChange(menuSelected.id, 'menuId')
          }}
          options={
            menusOptions.map(({ id, name }) => ({ label: name, value: id }))
          }
          style={styles.formSelect}
        />
      </div>
      <div style={styles.wrapper}>
        <h3 style={styles.label}>Category</h3>
        <FormSelect
          disabled={!(selectedMenu && selectedMenu.length > 0)}
          value={categoryTitle}
          onChange={(val) => {
            handleChange(val, 'categoryTitle')
          }}
          options={
            selectedMenu.map(({ title, name }) => ({ label: name[currentLang], value: title }))
          }
          style={styles.formSelect}
        />
      </div>
    </div>
  )
})

CategoryMenusContent.propTypes = {}
CategoryMenusContent.defaultProps = {}

export default CategoryMenusContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/categoryMenus/CategoryMenusContent.js